'use client'
import { motion } from "framer-motion";
import { useTranslations } from "next-intl";
import {
  FaFileAlt,
  FaNetworkWired,
  FaMedal,
  FaShieldAlt,
  FaHeadset,
  FaGlobe,
  FaTags,
  FaLock
} from "react-icons/fa";

const icons = [
    FaFileAlt, FaNetworkWired, FaMedal, FaShieldAlt,
    FaHeadset, FaGlobe, FaTags, FaLock
  ];

  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const item = {
    hidden: { y: 20, opacity: 0 },
    show: { y: 0, opacity: 1 }
  };

const FeaturesSection = () => {
  const t = useTranslations("features")

  return (
    <section
      className="py-20 px-4 md:px-8"
      style={{ backgroundColor: "var(--color-white)" }}
    >
      <div className="max-w-7xl mx-auto">
        <motion.h2
          className="text-3xl md:text-4xl font-bold text-center mb-16"
          style={{
            color: "var(--color-dark-navy)",
            fontFamily: "var(--font-arabic)"
          }}
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: false, amount: 0.5 }}
        >
          {t("title")}
        </motion.h2>

        <motion.div
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8"
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: false, margin: "-100px" }}
        >
          {t.raw("items").map((text: string, index: number) => {
            const Icon = icons[index];
            return (
              <motion.div
                key={index}
                className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 flex flex-col items-center text-center"
                style={{ borderTop: "4px solid var(--color-gold-bright)" }}
                variants={item}
                whileHover={{ y: -5 }}
              >
                <div className="flex items-center justify-center w-14 h-14 rounded-full mb-4" style={{ backgroundColor: "rgba(201, 176, 55, 0.1)" }}>
                  <Icon className="text-2xl" style={{ color: "var(--color-gold-bright)" }} />
                </div>
                <p className="text-lg font-medium" style={{ color: "var(--color-gray-light)", lineHeight: "1.8" }}>
                  {text}
                </p>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};

export default FeaturesSection;